import React from 'react';
import { graphql } from 'gatsby';
import { useTranslate } from 'gatsby-theme-soluble-source';

import CalculatorSectionDS from 'design-system/src/components/organisms/CalculatorSection';

import { onSubmitCalculator } from '../../utils/calculator';
import { getSrc } from '../../utils/media';

export default function CalculatorSection(props) {
    const translations = useTranslate();

    return (
        <CalculatorSectionDS
            {...props}
            mapToken={process.env.GATSBY_MAPBOX_TOKEN}
            translations={translations}
            benefits={
                props?.benefits?.length > 0
                    ? props.benefits.map((benefit: any) => ({
                          ...benefit,
                          icon: getSrc(benefit.icon),
                      }))
                    : []
            }
            onSubmit={onSubmitCalculator}
        />
    );
}

export const query = graphql`
    fragment DatoCmsCalculatorSection on DatoCmsCalculatorSection {
        title
        description
        formTitle
        formDescription
        calculatorTitle
        calculatorDescription
        submitTitle
        submitDescription
        caption
        benefits {
            ...Point
        }
        backButton {
            ...Button
        }
        form {
            ...Form
        }
    }
`;
